export enum HTTP_CODES {
  /** Відповіді не було зовсім: немає мережі, запит обірвано браузером */
  NO_RESPONSE = 0,
  SUCCESS = 200,
  /** Нижня межа клієнтських помилок (400..499) */
  CLIENT_ERROR = 400,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  GONE = 410,
  PAYLOAD_TOO_LARGE = 413,
  TOO_MANY_REQUESTS = 429,
  /** Нижня межа серверних помилок (500..599) */
  SERVER_ERROR = 500
}
